<template>
  <router-link
    id="ProductCard"
    class="card"
    :to="`/product/${item.GoodsID}`"
    :target="newTab ? '_blank' : ''"
  >
    <div
      class="image_box"
      :class="item.SellStatus != 'normal' ? 'unavailable' : ''"
    >
      <div v-if="item.SellStatus != 'normal'" class="status_box">
        <p class="sell_status">{{ item.SellStatus }}</p>
      </div>
      <LazyLoadingImage
        :src="$store.getters.imageUrl(item.Image1)"
        :alt="item.Title"
      />
    </div>
    <h4 class="title">{{ item.Title }}</h4>
    <div class="tag_box" v-if="item.Tags.length > 1">
      <span>
        {{ $store.getters.moneyFormat(item.Tags[1]) }} km．{{ item.Tags[0] }}
      </span>
    </div>
    <div class="discount_box" v-if="item.DiscountTypeList.length > 0">
      <span
        v-for="(discount, discount_index) in item.DiscountTypeList"
        :key="`discount_${discount_index}`"
      >
        {{ discount }}
      </span>
    </div>

    <div class="price_box">
      <p class="sell_price">
        NT${{ $store.getters.moneyFormat(item.MinPriceStock.SellPrice) }}
      </p>
      <p
        class="price"
        v-if="item.MinPriceStock.SellPrice != item.MinPriceStock.Price"
      >
        NT${{ $store.getters.moneyFormat(item.MinPriceStock.Price) }}
      </p>
    </div>
    <div class="bg_box"></div>
  </router-link>
</template>

<script>
import LazyLoadingImage from "@/components/LazyLoadingImage.vue";
export default {
  name: "ProductCard",
  components: {
    LazyLoadingImage,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    newTab: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
